
































import { Component, Vue, Ref, Mixins } from "vue-property-decorator";
import VMap from "@/components/Scouting/Map.vue";
import GroupSidebar from "@/components/Analysis/GroupSidebar.vue";
import { currentScoutingStore } from "@/store/typed";
import { ScoutingAnalysis } from "@/models/Scouting";
import { ScoutingArea, ScoutingPlace } from "@/models";
import { GOOGLE_MAPS_API_KEY } from "@/utils/Constants";
import { ScoutingGroupCreateDTO } from "@/models/ScoutingGroup";
import ScoutingGroupMixin from "@/mixins/http/ScoutingGroupMixin";
import ScoutingGroupHelperMixin from "@/mixins/ScoutingGroupHelperMixin";

@Component({
  components: {
    VMap,
    GroupSidebar,
  },
})
export default class Create extends Mixins(
  ScoutingGroupHelperMixin,
  ScoutingGroupMixin
) {
  async mounted() {
    await this.loadGoogleMaps();

    this.analysis =
      currentScoutingStore.scoutingAnalysis ||
      (await currentScoutingStore.loadScoutingAnalysis(this.analysisId)) ||
      null;
  }

  goBack() {
    this.$router.push({
      name: "company_analysis",
      params: {
        id: this.companyId,
        analysisId: this.analysisId,
      },
    });
  }

  async save(payload: ScoutingGroupCreateDTO) {
    if (!this.analysis) {
      return;
    }

    const group = await this.saveScoutingGroup(this.analysisId, payload);
    this.analysis.scouting.scoutingGroups.push(group);
    currentScoutingStore.setScoutingAnalysis(this.analysis);
    this.goBack();
  }
}
